import { Component, EventEmitter, Output } from "@angular/core";
import { AuthSession } from "./auth-session";

@Component({
    template: "",
    standalone: false
})
export class AuthEvents {
    @Output()
    public loginSuccessfulEvent: EventEmitter<AuthSession> = new EventEmitter();
    
    @Output()
    public logoutSuccessfulEvent: EventEmitter<any> = new EventEmitter();
}